<template>
  <div v-loading="loading" class="extra-questions">
    <el-table
      border
      :key="evaluation.id"
      size="mini"
      :data="evaluation.extra_questions"
    >
      <el-table-column label="Вопрос">
        <template v-slot="scope">
          <click-to-edit
            v-model="scope.row.name"
            :word-limit="1000"
            style="width: 100%; height: 100%; margin: 0"
            type="textarea"
            @input="updateQuestion(scope.row)"
            :autosize="{ minRows: 3, maxRows: 6}"
          ></click-to-edit>
        </template>
      </el-table-column>

      <el-table-column width="45" align="right">
        <template v-slot="scope">
          <el-popconfirm
            style="float: left"
            confirm-button-text='Да'
            cancel-button-text='нет'
            icon="el-icon-question"
            title="Вы уверены, что хотите удалить вопрос?"
            @confirm="deleteQuestion(scope.row)"
          >
            <el-button
              slot="reference"
              class="table-action-button"
              size="mini"
              round
              icon="far fa-trash-alt"
            >
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <el-button
      type="text"
      size="mini"
      icon="fas fa-plus"
      @click="createQuestion"
    >
      Добавить вопрос
    </el-button>
  </div>
</template>

<script>
import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "eval_extra_questions",
  components: {
    ClickToEdit,
  },
  props: {
    evaluation: { type: Object, required: true},
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    getQuestions() {
      this.loading = true;
      this.$api.evaluation.questionSearch({
        evaluation_id: this.evaluation.id,
      })
        .then(({data}) => {
          this.$set(this.evaluation, 'extra_questions', data.extra_questions);
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    updateQuestion(scope) {
      this.loading = true;
      this.$api.evaluation.questionUpdate({
        id: scope.id,
        name: scope.name ?? null,
      })
        .then(data => {
          this.$notify.success({
            title: 'Обновлено',
            message: 'Вопрос успешно обновлен'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    createQuestion() {
      this.loading = true;
      this.$api.evaluation.questionCreate({
        evaluation_id: this.evaluation.id,
      })
        .then(data => {
          this.getQuestions();
          this.$notify.success({
            title: 'Сохранено',
            message: 'Вопрос успешно добавлен'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
    deleteQuestion(scope) {
      this.loading = true;
      this.$api.evaluation.questionDelete({
        ids: [scope.id],
      })
        .then(data => {
          this.getQuestions();
          this.$notify.success({
            title: 'Удалено',
            message: 'Вопрос успешно удален'
          });
        })
        .finally(()=>{
          this.loading = false;
        })
    },
  }
}
</script>

<style scoped>

</style>